import 'babel-polyfill';
import 'isomorphic-fetch';

import Vue from 'vue';
import router from './router';
import store from './store';

import './registerServiceWorker';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './plugins/vuetify';
import './plugins/chartist';
import './plugins/amplify';
import './plugins/tinymce';

import './filters/stringToDate';
import './filters/sibDateToDate';
import './filters/categories';
import './filters/trueFalseTranslator';

import App from './App.vue';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
